import styled from 'styled-components';
import { BackgroundColor, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { Body5Medium, BodyFlexMedium, Caption1Regular } from 'styles/Global/typography';
import GenderMan from 'assets/Icons/Gender/GenderMan';
import GenderWoman from 'assets/Icons/Gender/GenderWoman';
import { ValueType } from 'models/Common/commonTypes';

type InfoContentsProps = {
    clientInfo: ValueType;
    selectedReasonIdx?: number | null;
    counselReasons?: Array<{ text: string }>;
    otherReason?: string;
};

export default function InfoContents({ clientInfo, selectedReasonIdx, counselReasons = [], otherReason = '' }: InfoContentsProps) {
    const formatPhoneNumber = (phoneNumber: string) => {
        const cleaned = ('' + phoneNumber).replace(/\D/g, '');

        if (cleaned.length < 10) return cleaned;

        return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7, 11)}`;
    };

    const parseBirthDay = (date: string) => {
        const cleaned = ('' + date).replace(/\D/g, '');

        const year = cleaned.slice(0, 4); // 연도
        const month = cleaned.slice(4, 6); // 월
        const day = cleaned.slice(6, 8); // 일

        return `${year}.${month}.${day}`;
    };

    const getRelationText = (relationType: number) => {
        switch (relationType) {
            case 0:
                return '엄마';
            case 1:
                return '아빠';
            case 2:
                return '기타';
        }
    };

    const isOtherReason = selectedReasonIdx === 6;

    return (
        <DescContainer>
            <DescWrapper>
                <TesterInfoTitle>자녀 이름</TesterInfoTitle>
                <InfoContentsContainer>
                    <NameGenderWrapper>
                        <Body5Medium>{clientInfo.patientName}</Body5Medium>
                        {clientInfo.gender === '4' ? <GenderWoman $width='16px' $height='16px' /> : <GenderMan $width='16px' $height='16px' />}
                    </NameGenderWrapper>
                </InfoContentsContainer>
            </DescWrapper>
            <DescWrapper>
                <TesterInfoTitle>자녀 생년월일</TesterInfoTitle>
                <InfoContentsContainer>
                    <Body5Medium>{parseBirthDay(clientInfo.birthDate)}</Body5Medium>
                </InfoContentsContainer>
            </DescWrapper>
            <DescWrapper>
                <TesterInfoTitle>자녀 학령학기</TesterInfoTitle>
                <InfoContentsContainer>
                    <Body5Medium>{`${clientInfo.schoolAge} ${clientInfo.semester}`}</Body5Medium>
                </InfoContentsContainer>
            </DescWrapper>
            <DescWrapper>
                <TesterInfoTitle>주양육자</TesterInfoTitle>
                <InfoContentsContainer>
                    <RelationWrapper>
                        <Body5Medium>{getRelationText(Number(clientInfo.relationType))}</Body5Medium>
                        <Divide />
                        <Body5Medium>{clientInfo.parentName}</Body5Medium>
                    </RelationWrapper>
                </InfoContentsContainer>
            </DescWrapper>
            <DescWrapper>
                <TesterInfoTitle>연락처</TesterInfoTitle>
                <InfoContentsContainer>
                    <Body5Medium>{formatPhoneNumber(clientInfo.patientMobile)}</Body5Medium>
                </InfoContentsContainer>
            </DescWrapper>
            {selectedReasonIdx && (
                <DescWrapper>
                    <TesterInfoTitle>검사 동기</TesterInfoTitle>
                    <InfoContentsContainer>
                        <BodyFlexMedium
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 5,
                                WebkitBoxOrient: 'vertical',
                                wordBreak: 'break-word',
                            }}
                        >
                            {isOtherReason ? `${counselReasons[selectedReasonIdx - 1]?.text} - ${otherReason}` : counselReasons[selectedReasonIdx - 1]?.text}
                        </BodyFlexMedium>
                    </InfoContentsContainer>
                </DescWrapper>
            )}
        </DescContainer>
    );
}

const DescContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 14px 16px;
    gap: 8px;
    background-color: ${BackgroundColor.color_background_primary_neutral};
`;

const DescWrapper = styled.div`
    display: flex;
    gap: 17px;
    align-items: flex-start;
    justify-content: start;
`;

const TesterInfoTitle = styled(Caption1Regular)`
    width: 80px;
    color: ${TextColor.color_text_light};
    padding-top: 2px;
`;

const InfoContentsContainer = styled(Caption1Regular)`
    width: 132px;
    color: ${TextColor.color_text_light};
    padding-top: 2px;
`;

const NameGenderWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 2px;
`;

const RelationWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
`;

const Divide = styled.div`
    width: 1px;
    height: 12px;
    background-color: ${BorderColor.color_border_normal};
    opacity: 0.3;
`;
